export default __webpack_public_path__ + "static/media/480_dummy2016-kunstgalerie01-mobile-de.810eade8.png";